/**
 * Chooses the chunk duration the seek timeline should advance by.
 *
 * Neither input is guaranteed positive: the measured value is whatever the
 * player last reported into the duration cache, and the chapter estimate is a
 * plain `Finite` wire field. A non-positive duration must not reach the prefix
 * sums — zero collapses the chunks after it onto one position and a negative
 * one rewinds the timeline — so it counts as "no duration known".
 */
export function effectiveChunkDurationMs(
  measuredMs: number | undefined,
  estimatedMs: number,
) {
  if (isUsableDurationMs(measuredMs)) return measuredMs;
  return isUsableDurationMs(estimatedMs) ? estimatedMs : 0;
}

function isUsableDurationMs(ms: number | undefined): ms is number {
  return ms !== undefined && Number.isFinite(ms) && ms > 0;
}
